export enum FwProgressBarColor {
  Primary = 'primary',
  Secondary = 'secondary',
  Orange = 'orange',
  Red = 'red',
  Green = 'green'
}

export enum FwProgressBarStatusColor {
  Grey = 'grey',
  Red = 'red',
  Orange = 'orange',
  Green = 'green'
}
